<div class="advert" [appPhotoGalleryGroup]="{ clickMode: 'single' }">
  @if (advert.images && advert.images.length) {
    @for (img of advert.images; let i = $index; track i) {
      <img [appPhotoGallery]="{ mimeType: 'image/png', url: img.url }"
           class="w-100 click-css"
           [src]="img.url"
           alt="advert image {{i}}"
           [ngClass]="{ 'd-none': i }">
    }
  }

  <div class="advert-extra">
    <div class="info-wrapper">
      <app-icon>info</app-icon>
      <div class="info">
        <a target="_blank" class="info-item-content text-black" [href]="advert.url">{{ advert.title }}</a>

        @if (advert.type === ADVERT_TYPE.OLX && advert.status) {
          <span class="status-badge" [ngStyle]="{ '--status-color': statusBadge.color }">
            {{ statusBadge.label | translate }}
          </span>
        }

        @if (advert.contact && advert.contact.name) {
          <span class="info-item">
            <span class="info-item-tooltip">{{ 'first_name' | translate }}</span>
            <span class="info-item-content">{{ advert.contact.name }}</span>
          </span>
        }

        @if (advert.contact && advert.contact.phone) {
          <span class="info-item">
            <span class="info-item-tooltip">{{ 'telephone' | translate }}</span>
            <span class="info-item-content">{{ advert.contact.phone }}</span>
          </span>
        }

        @if (advert.price && Object.keys(advert.price).length) {
          <span class="info-item">
            <span class="info-item-tooltip">{{ 'price'| translate }}</span>
            @if (advert.price.trade) {
              <span class="info-item-content">
                {{ 'trade' | translate }}
              </span>
            }
            @if (advert.price.value || advert.price.value === 0) {
              <span class="info-item-content">
                {{ parseCurrencyXXX(advert.price.value, advert.price.currency) }}
                @if (advert.price.negotiable) {
                  <span>
                    ({{ 'negotiable'| translate }})
                  </span>
                }
              </span>
            }
          </span>
        }

        @if (advert.double_price && (advert.double_price.usd || advert.double_price.uah)) {
          <span class="info-item">
            <span class="info-item-tooltip">{{ 'price'| translate }}</span>
            <span class="info-item-content">
              @if (advert.double_price.usd) {
                {{ advert.double_price.usd }} $ •
              }
              @if (advert.double_price.uah) {
                {{ advert.double_price.uah }} {{ 'UAH' | translate }}
              }
            </span>
          </span>
        }

        @if (advert.category?.name) {
          <span class="info-item">
            <span class="info-item-tooltip">{{ 'category' | translate }}</span>
            <span class="info-item-content">{{ advert.category.name }}</span>
          </span>
        }

        @if (advert.address?.city?.name) {
          <span class="info-item">
            <span class="info-item-tooltip">{{ 'city' | translate }}</span>
            <span class="info-item-content">{{ advert.address.city.name }}</span>
          </span>
        }

        @if (advert.description) {
          <span class="info-item">
            <span class="info-item-tooltip">{{ 'description' | translate }}</span>
            <div (click)="toggleDescription()" [ngClass]="{ 'info-description': isTextClamped }"
                 class="d-flex justify-content-end align-items-end">
              <span
                #descriptionElement
                [ngClass]="{ 'info-item-content': isCollapsed }"
                [innerHTML]="advert.description | safeHtml">
              </span>
              @if (isTextClamped) {
                @if (isCollapsed) {
                  <app-icon>keyboard_arrow_down</app-icon>
                } @else {
                  <app-icon>keyboard_arrow_up</app-icon>
                }
              }
            </div>
          </span>
        }
      </div>
    </div>

    @if (advert.type === ADVERT_TYPE.OLX) {
      @for (item of actions; track $index) {
        <label [ngClass]="{ 'advert-extra-item-disabled': item.is_disabled}"
               matRipple
               (click)="!item.is_disabled ? item.action() : null"
               class="advert-extra-item click-css">
          <app-icon>{{ item.icon }}</app-icon>
          <span class="text-truncate">{{ item.title | translate }}</span>
        </label>
      }
    }
  </div>
</div>
